import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AccordionClass } from ".";

interface AuctionsAccordionProps {
  auctionCalculated: string | null;
  t: (key: string) => string;
}

export function AuctionsAccordion({
  auctionCalculated,
  t,
}: AuctionsAccordionProps) {
  if (!auctionCalculated) return null;

  return (
    <AccordionItem value="auctions">
      <AccordionTrigger>{t("singleArtworkSubtitleAuction")}</AccordionTrigger>
      <AccordionContent>
        <div
          dangerouslySetInnerHTML={{
            __html: auctionCalculated,
          }}
          className={AccordionClass}
        />
      </AccordionContent>
    </AccordionItem>
  );
}
